import { Store } from 'app/model/cris/store';
import { StoreKeyword } from 'app/model/cris/store-keyword';
import { RestfulApiService } from 'app/services/restful-api.service';
import { ModelPrepped, ModelWithoutId } from 'app/type';

class KeywordService extends RestfulApiService<StoreKeyword, Store> {
    protected getFormName(): string {
        return 'store_keyword';
    }

    protected getPath(parent: Store | undefined): string {
        if (!parent) {
            throw new Error('Parent store is required in AttributeService');
        }

        return `stores/${parent.id}/keywords`;
    }

    protected prepareSaveData(entity: ModelWithoutId<StoreKeyword>): ModelPrepped<StoreKeyword> {
        return {
            ...entity,
            nameKeyword: undefined,
        };
    }
}

export const keywordService = new KeywordService();
